export const DOCUMENT_UPLOAD_LIMIT = 1024;
